import { ExpoRouterDemoScreen, ExpoRouterDemoSitemap } from '../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen centered={false}>
      <ExpoRouterDemoSitemap />
    </ExpoRouterDemoScreen>
  );
}
